module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/info_prompt@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoBetBar/info_prompt@1x.png
// module id = 199
// module chunks = 0